<template>
    <div class="automation-wizard-form-field">
        <!-- Select field -->
        <AutomationWizardFieldSelect
            v-if="field.type === 'select'"
            :field="field"
            :value="value"
            @update:value="handleUpdateValue"
        />

        <!-- Pipeline step opportunity field -->
        <AutomationWizardFieldPipelineStepOpp
            v-else-if="field.type === 'pipeline_step_opp'"
            :field="field"
            :value="value"
            :formData="formData"
            @update:value="handleUpdateValue"
        />
    </div>
</template>

<script>
import AutomationWizardFieldSelect from './Fields/AutomationWizardFieldSelect.vue';
import AutomationWizardFieldPipelineStepOpp from './Fields/AutomationWizardFieldPipelineStepOpp.vue';

export default {
    name: 'AutomationWizardFormField',
    components: {
        AutomationWizardFieldSelect,
        AutomationWizardFieldPipelineStepOpp,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Object, Boolean, Array],
            default: '',
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['update:value'],
    methods: {
        handleUpdateValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
